// Google Ads Remarketing helpers — körs bara om ad_storage är granted
// eftersom Consent Mode v2 redan är aktivt i __root.tsx.

import { isAppMode } from "./app-mode";

const AW_ID = "AW-18146160856";

function gtagSafe(event: string, params?: Record<string, unknown>) {
  if (typeof window === "undefined") return;
  // App-mode (Expo WebView): all Google Ads remarketing events are suppressed
  // per Play/App Store policy. Plausible + GA measurement stay untouched.
  if (isAppMode()) return;
  try {
    (window as any).gtag?.("event", event, { send_to: AW_ID, ...params });
  } catch {
    /* ignore — får inte blockera appen */
  }
}

/** Skickas vid route-byte så Google Ads kan bygga URL-baserade audiences. */
export function remarketingPageView(path: string) {
  gtagSafe("page_view", { page_path: path });
}

/** Pricing-sidan = användaren tittar på produkter. */
export function remarketingViewItemList(items: { id: string; name: string; price: number }[]) {
  gtagSafe("view_item_list", {
    currency: "SEK",
    items: items.map((i) => ({
      item_id: i.id,
      item_name: i.name,
      price: i.price,
    })),
  });
}

/** Enskild produktsida (t.ex. 10 dagar eller 30 dagar). */
export function remarketingViewItem(plan: string, price: number) {
  gtagSafe("view_item", {
    currency: "SEK",
    value: price,
    items: [{ item_id: plan, item_name: plan, price }],
  });
}

/** Användaren går till kassan. */
export function remarketingBeginCheckout(plan: string, price: number) {
  gtagSafe("begin_checkout", {
    currency: "SEK",
    value: price,
    items: [{ item_id: plan, item_name: plan, price }],
  });
}

/** Köp genomfört — kompletterar den befintliga conversion-taggen. */
export function remarketingPurchase(plan: string, price: number, transactionId: string) {
  gtagSafe("purchase", {
    currency: "SEK",
    value: price,
    transaction_id: transactionId,
    items: [{ item_id: plan, item_name: plan, price }],
  });
}

/** Ny användare registrerad. */
export function remarketingSignUp(method: "email" | "google" | "apple") {
  gtagSafe("sign_up", { method });
}

/** Användaren startar övning/prov — hög engagemangssignal. */
export function remarketingEngage(activity: "exam" | "practice" | "free_quiz") {
  gtagSafe("engage", { activity_type: activity });
}
